import React from "react";

const TextError = (props) => {
	return <div style={{ color: "red", paddingLeft: "2rem" }}>{props.children}</div>;
};

export default TextError;
